import { useState, useEffect, useCallback, useRef } from 'react';
import DatePicker from 'react-datepicker';   
import 'react-datepicker/dist/react-datepicker.css';   
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from 'react-helmet-async';
import { Link, Link as RouterLink, useNavigate, useParams, useLocation, NavLink } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import QRCode from 'qrcode.react';

import Multiselect from 'multiselect-react-dropdown';
import "react-data-table-component-extensions/dist/index.css";
import * as React from 'react';
import $ from 'jquery';
import TableToExcel from '@linways/table-to-excel';
import DataTable from 'react-data-table-component';
import * as XLSX from 'xlsx'; 
// @mui
import { styled, useTheme } from '@mui/material/styles';
import { Button, Typography, Container, Box, Modal } from '@mui/material';
import * as userActions from "../../actions/userActions";
import config from "../../config";
import { encryptData } from '../../utils/cryptoUtils';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle';
import '../common.scss';
import * as reportActions from "../../actions/reportActions";
import Loader from "../../components/Loader";
import LogsVersioning from './LogsVersioning';

import AccessDenied from '../common/AccessDenied';
import * as beatPlanActions from "../../actions/beatPlanActions";
import * as masterAction from "../../actions/masterAction";

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
    maxWidth: 480,
    margin: 'auto',
    minHeight: '100vh',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------
const EnachTransactionSchedulingV2 = (props) => {
    const theme = useTheme();
    const { id } = useParams();
    const { urlAgreementNo } = useParams();
    const { brief } = useParams();
     const location = useLocation();
    const { actions, usersData } = props;
    const { register, handleSubmit, formState: { errors }, setValue, reset } = useForm();
    const navigate = useNavigate();

    const [permissions, setPermissions] = useState([]);
    const [userRoleType, setUserRoleType] = useState('User');
    const [loggeInUserID, setLoggeInUserID] = useState('');

    const [allLoggedinUserChild, setAllLoggedinUserChild] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [businessDoneLoans, setBusinessDoneLoans] = useState([]);
    const [loanDetailsEMIS, setLoanDetailsEMIS] = useState([]);
    const [presentedLoans, setPresentedLoans] = useState([]);

    const [total, setTotal] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState('');

    const [sendCrifOpenModal, setSendCrifOpenModal] = React.useState(false);
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [sendCrifFormData, setSendCrifFormData] = useState({ email_address: '' });
    const [preloaderStatus, setPreloaderStatus] = useState(false);

    const [viewModulePermissionStatus, setViewModulePermissionStatus] = useState(false);
    const [userHasPermission, setUserHasPermission] = useState(true);

    const [beatPlanLocation, setBeatPlanLocation] = useState([]);
    const [allCampaigns, setAllCampaigns] = useState([]);
    const [selectedVisitType, setSelectedVisitType] = useState([]);
    const [loanID, setLoanID] = useState('');
    const [loanDetailStatus, setLoanDetailStatus] = useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [versioningLoans, setVersioningLoans] = useState([]);
	const [businessDoneLoan, setBusinessDoneLoan] = useState([]);
    const [reportName, setReportName] = useState('');
    const [cronRunDateArr, setCronRunDateArr] = useState([]);
    const [cronRunTabsReloadStatus, setCronRunTabsReloadStatus] = useState(true);
    const [activeLoanTab, setActiveLoanTab] = useState(0);
    const [auditAllLoansButtonStatus, setAuditAllLoansButtonStatus] = useState(false);

    const [keyword, setKeyword] = useState('');
    const [isENACHRegistrationChecked, setIsENACHRegistrationChecked] = useState(true);
    const [isENACHViewAllChecked, setIsENACHViewAllChecked] = useState(false); 
    const [isENACHViewManualChecked, setIsENACHViewManualChecked] = useState(false);

    const [userId, setUserId] = useState(''); 
    const[intentUrl, setIntentUrl] = useState('');
    const [totalOutstandingAmt, setTotalOutstandingAmt] = useState(0);
    const [loadDefaultQR, setLoadDefaultQR] = useState(false);
    const [formValues, setFormValues] = useState({
        amount: ''
    });
    const [runENACHTransactionsApis, setRunENACHTransactionsApis] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);
    
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [partialAmount, setPartialAmount] = useState('');
    const [partialDebitDate, setPartialDebitDate] = useState('');
    const [bankDebitDate, setBankDebitDate] = useState('');
    const [isBulkPresentationEnabled, setIsBulkPresentationEnabled] = useState(false);
    const [disableBtn, setDisableBtn] = useState(false);
    const [exportFilter, setExportFilter] = useState('All');
    const RECORDS_PER_PAGE = 100;
    const isSearching = useRef(false);
    const isInitialMount = useRef(true);
    const isDateChanging = useRef(false);

    useEffect(() => {

        if (brief !== undefined ) {
            setReportName(brief); 
        }
        // check user is logged-in or not
        const authToken = localStorage.getItem('authToken');
        if (authToken === null) {
            navigate('/login');
        }

        if (id !== undefined ) {
            const idVal = atob(id);            
            setLoanID(idVal); 
             setLoanDetailStatus(true);
        } 
    }, [setLoanID,id,setReportName]);

    useEffect(() => {
        const obj = { 'start': '0', 'length': config.MAX_RECORDS };
        const requestData = encryptData(obj);
        const response = actions.getUserModuleData(requestData);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            if (result.data.success === 1) {
                const permissionsData = result.data.data;
                setPermissions(permissionsData);
                const hasViewPermissions = permissionsData.find(permission => permission.module_name === 'Audit Report')?.view_permission;
                setPermissions(permissionsData);
                setViewModulePermissionStatus(hasViewPermissions);
                setUserHasPermission(hasViewPermissions);

                if (Object.prototype.hasOwnProperty.call(result.data, 'user_info') && Object.prototype.hasOwnProperty.call(result.data.user_info[0], 'role_type') && result.data.user_info[0].role_type !== '') {
                    setUserRoleType(result.data.user_info[0].role_type);
                    // alert(result.data.user_info[0].role_type);
                    setLoggeInUserID(result.data.user_info[0].user_id);
                }
            }
        }).catch((error) => {
            // console.error("Promise rejected -  lead list:", error);
        });
    }, [setPermissions, setUserHasPermission, setUserRoleType, setLoggeInUserID]);

     
    const reInitOpenEnachForm = () => {
        setOpenEnach(false); 
        setPartialAmount('');
        setPartialDebitDate(''); 
    }

    
    const [rows, setRows] = useState(
        selectedRows.map((item) => ({ ...item, bulk_selected: false, bulk_amount: "" }))
      );
    // Handle Checkbox Change for each row
    const handleCheckboxChange = (id) => {
        const updated = rows.map((row) => {
          if (row.loanID === id) {
            return { ...row, bulk_selected: !row.bulk_selected };
          }
          return row;
        });
      
        setRows(updated);

        console.log(" individual change rows = ",updated);
      
        if (selectedRows.includes(id)) {
          setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
        } else {
          setSelectedRows([...selectedRows, id]);
        }
      };

      const handleAmountChange = (id, value) => {

       
        const updated = rows.map((row) => {
          if (row.loanID === id) {
            return { ...row, bulk_amount: value };
          }
          return row;
        });
        setRows(updated);
        console.log(" change rows = ",rows);
        
      };

    // Handle Select All
    const handleSelectAll = () => {
        const allIds = businessDoneLoans.map((row) => row.loanID);
        setSelectedRows(allIds);
        setRows(rows.map((row) => ({ ...row, bulk_selected: true })));
        console.log(" ckeck all rows = ",rows);
      };
      
      // Unselect All
      const handleUnselectAll = () => {
        setSelectedRows([]);
        setRows(rows.map((row) => ({ ...row, bulk_selected: false })));
        console.log(" unckeck all rows = ",rows);
      };
    


    const checkLogout = () => {
        const authToken = localStorage.getItem('authToken');
        const logInTimestamp = localStorage.getItem('logInTimestamp');

        if (logInTimestamp !== null) {
            const loginTimestamp = parseInt(logInTimestamp, 10);
            const currentTime = Math.floor(Date.now() / 1000);
            const timeElapsed = currentTime - loginTimestamp;
            const autoLogoutTimeInSecod = config.AUTO_LOGOUT_TIME_IN_SECONDS;

            if (timeElapsed >= autoLogoutTimeInSecod) {
                const params = { 'login_token': authToken };
                console.log("params : ", params);
                const requestData = encryptData(params);
                const response = actions.userLogout(requestData);
                response.then((result) => {
                    if (result.data.success === 1) {
                        const data = {};
                        actions.loadUserAuth(false);
                        actions.loginDataSuccess(data);
                        localStorage.setItem("authToken", '');
                        localStorage.setItem("logInTimestamp", '');
                        navigate("/login");
                    }
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }

    useEffect(() => {
        checkLogout();
    });

    const handleKeywordChange = (event) => {
        setKeyword(event.target.value); 
    };
    const handleENACHRegistrationChange = (event) => {
         setIsENACHRegistrationChecked(event.target.checked);
    };

    const handleENACHViewAll = (event) => {
        setIsENACHViewAllChecked(event.target.checked);
   };

   const handleENACHViewManual = (event) => {
    setIsENACHViewManualChecked(event.target.checked);
};

    const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleTabClick = (index) => {
        setActiveLoanTab(index); // Update active tab index
        const clickedDate = cronRunDateArr[index].formatted_cron_run_date;
        
        if(clickedDate !== ''){
            setPreloaderStatus(true);

            
            
            const params = { 'start': '0', 'length': config.MAX_RECORDS, 'param': "audit_all_loans", 'clicked_date': clickedDate, 'keyword' : keyword , 'isENACHRegistrationChecked':isENACHRegistrationChecked ,'brief' : 'view_transaction_scheduling', 'filterDate' : selectedDate, 'partialAmount' : partialAmount, 'partialDebitDate' : partialDebitDate, 'bankDebitDate' : bankDebitDate, 'isENACHViewAllChecked':isENACHViewAllChecked ,"isENACHViewManualChecked":isENACHViewManualChecked, 'pageAction': "ckers", 'version' : 'version_2' };
            const requestData = encryptData(params);
            const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
            response.then((result) => {
                // console.log("Promise resolved -  getBusinessDoneLoansData:", result);
                if (result.data.success === 1) {
                    setPreloaderStatus(false);
                    reInitOpenEnachForm();  
                    const results = result.data.data.all_business_done_loans;
                    const resultArr = Object.keys(results).map((key) => results[key]);


                    const presults = result.data.data.presented_loans;
                    const presultArr = Object.keys(presults).map((key) => presults[key]);
                    
                    setTotal(result.data?.total || 0);
                    console.log("All loans  = ",resultArr);

                    // const cronRunDateResults = result.data.data.cron_run_date;
                    // const cronRunDateResultArr = Object.keys(cronRunDateResults).map((key) => cronRunDateResults[key]);
                  //  setCronRunDateArr(cronRunDateResultArr);

                    setBusinessDoneLoans(resultArr);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                    setPresentedLoans(presultArr);

                    const initializedRows = resultArr.map(item => ({
                        loanID:item.loanID,
                        leadId:item.leadId,
                        bulk_selected: false,
                        bulk_amount:
                                        item.PendingAmount !== '' && Number(item.PendingAmount) < Number(item.EMI)
                                          ? item.PendingAmount
                                          : item.EMI,
                      }));
                      setRows(initializedRows);
                } else {
                    setPreloaderStatus(false);
                    setBusinessDoneLoans([]);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                    setPresentedLoans([]);
                }
            }).catch((error) => {
                setPreloaderStatus(false);
                console.error("Promise rejected -  getBusinessDoneLoansData:", error);
            });
            reInitOpenEnachForm(); 
        }
    };

    const auditAllLoansButton = async () => {
        setPreloaderStatus(true);
        
        const params = { 'start': '0', 'length': config.MAX_RECORDS, 'param': "audit_all_loans", 'keyword' : keyword , 'isENACHRegistrationChecked':isENACHRegistrationChecked,'brief' : 'view_transaction_scheduling' , 'filterDate' : selectedDate , 'partialAmount' : partialAmount , 'partialDebitDate' : partialDebitDate  , 'bankDebitDate' : bankDebitDate, 'isENACHViewAllChecked':isENACHViewAllChecked,"isENACHViewManualChecked":isENACHViewManualChecked, 'pageAction': "ckers", 'version' : 'version_2' };
        const requestData = encryptData(params);
        const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  getBusinessDoneLoansData:", result);
            if (result.data.success === 1) {
                setAuditAllLoansButtonStatus(true);
                setPreloaderStatus(false);
                reInitOpenEnachForm();   
                const results = result.data.data.all_business_done_loans;
                const resultArr = Object.keys(results).map((key) => results[key]);

                const cronRunDateResults = result.data.data.cron_run_date;
                const cronRunDateResultArr = Object.keys(cronRunDateResults).map((key) => cronRunDateResults[key]);

                const presults = result.data.data.presented_loans;
                const presultArr = Object.keys(presults).map((key) => presults[key]);

                setTotal(result.data?.total || 0);

                setPresentedLoans(presultArr);

                 setCronRunDateArr(cronRunDateResultArr);

                setBusinessDoneLoans(resultArr);
                setLoanDetailsEMIS([]);
                setBusinessDoneLoan([]);

                const initializedRows = resultArr.map(item => ({
                    loanID:item.loanID,
                    leadId:item.leadId,
                    bulk_selected: false,
                    bulk_amount:
                            item.PendingAmount !== ''  && Number(item.PendingAmount) < Number(item.EMI)
                                ? item.PendingAmount
                                : item.EMI,
                  }));
                  setRows(initializedRows);
            } else {
                setPreloaderStatus(false);
                setBusinessDoneLoans([]);
                setLoanDetailsEMIS([]);
                setBusinessDoneLoan([]);
                setAuditAllLoansButtonStatus(false);
                setPresentedLoans([]);
            }
        }).catch((error) => {
            setPreloaderStatus(false);
            console.error("Promise rejected -  getBusinessDoneLoansData:", error);
        });
    };

    useEffect(() => {
        setPreloaderStatus(true);

        const today = new Date();
        const todayFormatted = formatDate(today);

        setStartDate(todayFormatted);
        setEndDate(todayFormatted);

        setValue("start_date", todayFormatted);
        setValue("end_date", todayFormatted);

        // console.log("111111 - id = ",id);

        if (id !== undefined ) {
            setBusinessDoneLoans([]);
            setLoanDetailsEMIS([]);
            setVersioningLoans([]);
            setPresentedLoans([]);
            const idVal = atob(id); 
            const agreementNo = atob(urlAgreementNo);  
            
            let reportName = '';
            if (brief !== undefined ) {
                reportName = brief; 
            }
            // alert(reportName);
            // alert(idVal);      
            setLoanID(idVal); 
             setLoanDetailStatus(true);
             setAuditAllLoansButtonStatus(true);
 
             const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted ,'loan_id' : idVal ,'loanAgreementNo' : agreementNo,'reportName' : reportName, 'keyword' : keyword , 'isENACHRegistrationChecked':isENACHRegistrationChecked,'brief' : 'view_transaction_scheduling' , 'filterDate' : selectedDate , 'partialAmount' : partialAmount, 'partialDebitDate' : partialDebitDate , 'bankDebitDate' : bankDebitDate, 'isENACHViewAllChecked':isENACHViewAllChecked, "isENACHViewManualChecked" : isENACHViewManualChecked, 'pageAction': "ckers", 'version' : 'version_2' };
                const requestData = encryptData(params);
                const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
                response.then((result) => {
                    // console.log("Promise resolved -  getBusinessDoneLoansData:", result);
                    if (result.data.success === 1) {
                        setPreloaderStatus(false);
                        reInitOpenEnachForm();
                        const results = result.data.data.all_business_done_loans;
                        const resultArr = Object.keys(results).map((key) => results[key]);
                        setVersioningLoans(resultArr);

                        setTotal(result.data?.total || 0);

                        const defaultTabIndex = (resultArr.length >0) ? (resultArr.length - 1) : 0;
                        setActiveTab(defaultTabIndex);

                        if (
                            results &&
                            results[0] &&
                            Object.prototype.hasOwnProperty.call(results[0], 'RepaymentSchedules')
                        ) {
                            // alert(results[0].AgreementNo);
                             setLoanDetailsEMIS(results[0].RepaymentSchedules);
                             setBusinessDoneLoan(results[0]);

                             setTotalOutstandingAmt(100);
                        }

                        // Mark initial mount as complete to allow pagination to work
                        isInitialMount.current = false;
                    } else {
                        setPreloaderStatus(false);
                        setBusinessDoneLoans([]);
                        setLoanDetailsEMIS([]);
                        setBusinessDoneLoan([]);

                        // Mark initial mount as complete
                        isInitialMount.current = false;
                    }
                }).catch((error) => {
                    setPreloaderStatus(false);
                    console.error("Promise rejected -  getBusinessDoneLoansData:", error);

                    // Mark initial mount as complete
                    isInitialMount.current = false;
                });
        }else{
            const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': todayFormatted, 'end_date': todayFormatted, 'keyword' : keyword , 'isENACHRegistrationChecked':isENACHRegistrationChecked,'brief' : 'view_transaction_scheduling', 'filterDate' : selectedDate  , 'partialAmount' : partialAmount , 'partialDebitDate' : partialDebitDate, 'bankDebitDate' : bankDebitDate, 'isENACHViewAllChecked':isENACHViewAllChecked , "isENACHViewManualChecked":isENACHViewManualChecked, 'pageAction': "ckers", 'version' : 'version_2' };
            const requestData = encryptData(params);
            const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
            response.then((result) => {
                // console.log("Promise resolved -  getBusinessDoneLoansData:", result);
                if (result.data.success === 1) {
                    setPreloaderStatus(false);
                    reInitOpenEnachForm();
                    const results = result.data.data.all_business_done_loans;
                    const resultArr = Object.keys(results).map((key) => results[key]);

                    const presults = result.data.data.presented_loans;
                    const presultArr = Object.keys(presults).map((key) => presults[key]);

                    setTotal(result.data?.total || 0);

                    setPresentedLoans(presultArr);

                    console.log("All loans  = ",resultArr);

                    console.log("All presented loans  = ",presultArr);

                    setBusinessDoneLoans(resultArr);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);

                    const initializedRows = resultArr.map(item => ({
                        loanID:item.loanID,
                        leadId:item.leadId,
                        bulk_selected: false,
                        bulk_amount:
                        item.PendingAmount !== '' && Number(item.PendingAmount) < Number(item.EMI)
                          ? item.PendingAmount
                          : item.EMI,
                      }));
                    setRows(initializedRows);

                    // Mark initial mount as complete to allow pagination to work
                    isInitialMount.current = false;
                } else {
                    setPreloaderStatus(false);
                    setBusinessDoneLoans([]);
                    setLoanDetailsEMIS([]);
                    setBusinessDoneLoan([]);
                    setPresentedLoans([]);

                    // Mark initial mount as complete
                    isInitialMount.current = false;
                }
            }).catch((error) => {
                setPreloaderStatus(false);
                console.error("Promise rejected -  getBusinessDoneLoansData:", error);

                // Mark initial mount as complete
                isInitialMount.current = false;
            });
        }

        
    }, [setBusinessDoneLoans,setLoanID,setLoanDetailsEMIS,setLoanDetailStatus,id, setBusinessDoneLoan,setVersioningLoans, setCronRunDateArr, setTotalOutstandingAmt,setPresentedLoans]);

    const onSubmit = (data) => {
        // Set flag to prevent useEffect from triggering during search
        isSearching.current = true;
        setPreloaderStatus(true);

        const params = {
            'keyword' : keyword,
            'filterDate' : selectedDate,
            'partialAmount' : partialAmount,
            'partialDebitDate' : partialDebitDate, 
            'bankDebitDate' : bankDebitDate,
            'isENACHViewAllChecked':isENACHViewAllChecked,
            'isENACHViewManualChecked' :isENACHViewManualChecked,
            'isENACHRegistrationChecked':isENACHRegistrationChecked,
            'brief' : 'view_transaction_scheduling',
            'runENACHTransactionsApis' : runENACHTransactionsApis,
            'start': '0',
            'length': RECORDS_PER_PAGE,
            'selectedRows' : selectedRows,
            'isBulkPresentationEnabled' : isBulkPresentationEnabled,
            'bulkRowsDetails' : (isBulkPresentationEnabled) ? rows : [],
            'pageAction': "ckers" , 'version' : 'version_2'   
        };

        console.log("total records = ",total);
        const requestData = encryptData(params);
        const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  lead list:", result);
            reInitOpenEnachForm();
            if (result.data.success === 1) {
                setPreloaderStatus(false);
                setDisableBtn(false);
                const results = result.data.data.all_business_done_loans;
                const resultArr = Object.keys(results).map((key) => results[key]);

                const presults = result.data.data.presented_loans;
                const presultArr = Object.keys(presults).map((key) => presults[key]);

                setTotal(result.data?.total || 0);

                setPresentedLoans(presultArr);
                setBusinessDoneLoans(resultArr);
                setSelectedRows([]);

                const initializedRows = resultArr.map(item => ({
                    loanID:item.loanID,
                    leadId:item.leadId,
                    bulk_selected: false,
                    bulk_amount:
                                item.PendingAmount !== '' && Number(item.PendingAmount) < Number(item.EMI)
                                    ? item.PendingAmount
                                    : item.EMI,
                  }));
                setRows(initializedRows);

                // Reset to page 1 after search
                setTotal(result.data?.total || 0);
                setCurrentPage(1);

                // Reset flag after state updates
                setTimeout(() => {
                    isSearching.current = false;
                }, 100);
            } else {
                setPreloaderStatus(false);
                setDisableBtn(false);
                setBusinessDoneLoans([]);
                setPresentedLoans([]);

                // Reset flag
                isSearching.current = false;

                if (result.data && Object.prototype.hasOwnProperty.call(result.data, 'message')) {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }else{
                    toast.error("There is some error,please try again!", {
                        position: "top-right",
                    });
                }
            }
         }).catch((error) => {
            setPreloaderStatus(false);
            setDisableBtn(false);
            isSearching.current = false;
            console.error("Promise rejected -  lead list:", error);
        });
    };

    const btnRunENACHBULKTransactions = () => {
        console.log("Selected ids = ",selectedRows);
        console.log("Selected rows = ",rows);

        if(selectedRows.length < 1){
            toast.error("Please select at least one loan record.", {
                position: "top-right",
            });
        }else if(!bankDebitDate || bankDebitDate === ''){
            toast.error("Please select a debit date before initiating E-NACH.", {
                position: "top-right",
            });
        }else{
            const confirmed = window.confirm(`Are you sure you want to BULK presentation E-NACH for the selected records? Please ensure that all selected records have valid debit dates ${bankDebitDate} and amounts before confirming.`);
            if (confirmed) {
                // Proceed with the action
                console.log("Code is running...");
                setIsBulkPresentationEnabled(true);
                setRunENACHTransactionsApis(true);
                setDisableBtn(true);
                // runYourFunction();
            } else {
                console.log("Action canceled.");
                setIsBulkPresentationEnabled(false);
                setRunENACHTransactionsApis(false);
                setDisableBtn(false);
            }
        }
    }

    const btnRunENACHTransactions = () => {
       // console.log("Selected rows = ",selectedRows);
       setIsBulkPresentationEnabled(false);
        if(selectedRows.length < 1){
            toast.error("Please select at least one loan record.", {
                position: "top-right",
            });
        }else if(!bankDebitDate || bankDebitDate === ''){
            toast.error("Please select a debit date before initiating E-NACH.", {
                position: "top-right",
            });
        }else if(selectedRows.length === 1){

            const selectedSingleID = '';

           // const allIds = businessDoneLoans.map(row => row.id);
          //  setSelectedRows(allIds);

           // console.log("allIds = ",selectedRows);
          //  console.log("allIds = ",allIds);

            setOpenEnach(true);
           // alert('one record');


        }else{
            // setRunENACHTransactionsApis(true);
            toast.error("Please present E-NACH records individually.", {
                position: "top-right",
            });

        }
    };

    useEffect(() => {
        if (runENACHTransactionsApis) {
             onSubmit();
             setRunENACHTransactionsApis(false);
        }
    }, [runENACHTransactionsApis]);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
        setCurrentPage(1); // Reset to the first page when searching
    };

    const filteredItems = businessDoneLoans.filter(item => {
        const AgreementNo = item.AgreementNo?.toLowerCase() || '';
        const CustomerName = item.CustomerName?.toLowerCase() || '';
        // const CustomerNo = item.CustomerNo?.toLowerCase() || '';
        return (
            AgreementNo.includes(searchQuery.toLowerCase()) ||
            CustomerName.includes(searchQuery.toLowerCase())
            // ||
            // CustomerNo.includes(searchQuery.toLowerCase())
        );
    });


    const isFutureMonth = (date) => {
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth();

        const selectedYear = date.getFullYear();
        const selectedMonth = date.getMonth();

        return selectedYear > currentYear || (selectedYear === currentYear && selectedMonth > currentMonth);
    };

    useEffect(() => {
        // Skip on initial mount (page load) to prevent double API call
        if (isInitialMount.current) {
            console.log(`Skipping API call - initial mount`);
            return;
        }

        // Skip if we're currently searching (to prevent double API calls)
        if (isSearching.current) {
            console.log(`Skipping API call - search in progress`);
            return;
        }

        // Skip if date is changing (to prevent double API calls)
        if (isDateChanging.current) {
            console.log(`Skipping API call - date change in progress`);
            return;
        }

        // Skip if currentPage is 0 or negative
        if (currentPage <= 0) {
            return;
        }

        console.log(`currentPage = ${currentPage}`);
        goBackBtnFromAuditAllLoans(currentPage);
    }, [currentPage]);

    // Watch for date changes and fetch data
    useEffect(() => {
        // Skip on initial mount
        if (isInitialMount.current) {
            return;
        }

        // Skip if viewing loan details
        if (loanDetailStatus) {
            return;
        }

        console.log(`selectedDate changed - fetching data`);

        // Set flag to prevent currentPage useEffect from triggering
        isDateChanging.current = true;

        // Reset to page 1 and fetch data with new date
        setPreloaderStatus(true);
        
        const params = {
            'start': '0',
            'length': RECORDS_PER_PAGE,
            'keyword': keyword,
            'isENACHRegistrationChecked': isENACHRegistrationChecked,
            'brief': 'view_transaction_scheduling',
            'filterDate': selectedDate,
            'partialAmount': partialAmount,
            'partialDebitDate': partialDebitDate,
            'bankDebitDate': bankDebitDate,
            'isENACHViewAllChecked': isENACHViewAllChecked,
            'isENACHViewManualChecked': isENACHViewManualChecked,
            'pageAction': "ckers" , 'version' : 'version_2' 
        };

        const requestData = encryptData(params);
        const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
        response.then((result) => {
            if (result.data.success === 1) {
                setPreloaderStatus(false);
                reInitOpenEnachForm();
                const results = result.data.data.all_business_done_loans;
                const resultArr = Object.keys(results).map((key) => results[key]);

                const presults = result.data.data.presented_loans;
                const presultArr = Object.keys(presults).map((key) => presults[key]);

                setTotal(result.data?.total || 0);
                setPresentedLoans(presultArr);
                setBusinessDoneLoans(resultArr);

                const initializedRows = resultArr.map(item => ({
                    loanID: item.loanID,
                    leadId: item.leadId,
                    bulk_selected: false,
                    bulk_amount:
                        item.PendingAmount !== '' && item.PendingAmount > 0 && Number(item.PendingAmount) < Number(item.EMI)
                            ? item.PendingAmount
                            : item.EMI,
                }));
                setRows(initializedRows);

                // Reset currentPage to 1 after data is loaded
                setCurrentPage(1);

                // Reset flag after a short delay
                setTimeout(() => {
                    isDateChanging.current = false;
                }, 100);
            } else {
                setPreloaderStatus(false);
                setBusinessDoneLoans([]);
                setPresentedLoans([]);

                // Reset currentPage and flag
                setCurrentPage(1);
                setTimeout(() => {
                    isDateChanging.current = false;
                }, 100);
            }
        }).catch((error) => {
            setPreloaderStatus(false);
            console.error("Promise rejected - date change:", error);

            // Reset flag on error
            isDateChanging.current = false;
        });
    }, [selectedDate]);

    useEffect(() => {
        // Reset status filter to 'All' when month changes and it's not a future month
        if (!isFutureMonth(selectedDate)) {
            setExportFilter('All');
        }
    }, [selectedDate]);

    const startIndex = (currentPage - 1) * RECORDS_PER_PAGE;
    const endIndex = startIndex + RECORDS_PER_PAGE;
    const paginatedItems = filteredItems.slice();
   // const totalPages = Math.ceil(filteredItems.length / RECORDS_PER_PAGE);
    const totalPages = Math.ceil(total / RECORDS_PER_PAGE);

    // Frontend filtering based on status
    const getFilteredLoans = () => {
        if (isFutureMonth(selectedDate)) {
            return businessDoneLoans;
        }

        if (exportFilter === 'All') {
            return businessDoneLoans;
        }

        if (exportFilter === 'Success') {

            
            return businessDoneLoans.filter(loan =>
              /*  loan?.transaction_verification_data?.LatestEnachTransactionVerificationStatus?.toLowerCase() === 'success' || */
                loan?.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'S'
            );
        }
 
        if (exportFilter === 'Failed') {
            return businessDoneLoans.filter(loan =>
                loan?.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'F' /* ||
                loan?.transaction_verification_data?.LatestEnachTransactionVerificationStatus?.toLowerCase() === 'failed' */
            );
        }

        return businessDoneLoans;
    };

    const filteredBusinessDoneLoans = getFilteredLoans();
     
    const exportLoansReport = async () => {
        const table = document.getElementById('exportLoansReportExcelFile');
        
        // Debugging log: Check if table is correctly selected
        console.log('Table:', table);
        
        const headersRow = table.querySelector('thead tr');
        const headers = Array.from(headersRow.querySelectorAll('th'));
        const actionColumnIndex = headers.findIndex(th => th.innerText.trim() === 'Action');
        
        // Debugging logs: Check headersRow and actionColumnIndex
        console.log('Headers Row:', headersRow);
        console.log('Action Column Index:', actionColumnIndex);
        
        if (actionColumnIndex !== -1) {
            // Debugging log: Check the header element to remove
            console.log('Header to Remove:', headers[actionColumnIndex]);
            
            headersRow.removeChild(headers[actionColumnIndex]);
        } else {
            console.log('Action column not found.');
        }
    
        TableToExcel.convert(table, {
            name: 'Audit-Report.xlsx',
            sheet: {
                name: 'Audit-Report',
            },
        });
    
        // Re-append the action column header if it was removed
        if (actionColumnIndex !== -1) {
            headersRow.appendChild(headers[actionColumnIndex]);
        }
    };

    const getLocation = (beatPlanId, btnAction, id) => {

        setPreloaderStatus(true);

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {

                const latitude = position.coords.latitude;
                const longitude = position.coords.longitude;

                if(latitude !== "" && longitude !== ""){
            
                    const params = {
                        'id': id,
                        'beat_plan_id': beatPlanId,
                        'btnAction': btnAction,
                        'latitude': latitude,
                        'longitude': longitude
                    };
                    
                    const requestData = encryptData(params);
                    const response = actions.setBeatPlanStatus(requestData, false);
                    response.then((result) => {
                        if (result.data.success === 1) {
                            
                            toast.success(result.data.message, {
                                position: "top-right",
                            });
                            // setPreloaderStatus(false);
                            const params = { 'start': '0', 'length': config.MAX_RECORDS, 'start_date': startDate, 'end_date': endDate, 'keyword' : keyword , 'isENACHRegistrationChecked':isENACHRegistrationChecked,'brief' : 'view_transaction_scheduling', 'filterDate' : selectedDate , 'partialAmount' : partialAmount, 'partialDebitDate' : partialDebitDate , 'bankDebitDate' : bankDebitDate, 'isENACHViewAllChecked':isENACHViewAllChecked ,'isENACHViewManualChecked':isENACHViewManualChecked, 'pageAction': "ckers" , 'version' : 'version_2' };
                            const requestData = encryptData(params);
                            const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
                            response.then((result) => {
                                // console.log("Promise resolved -  getBusinessDoneLoansData:", result);
                                if (result.data.success === 1) {
                                    setPreloaderStatus(false);
                                    reInitOpenEnachForm();  
                                    const results = result.data.data.all_business_done_loans;
                                    const resultArr = Object.keys(results).map((key) => results[key]);
                                    setBusinessDoneLoans(resultArr);

                                    const presults = result.data.data.presented_loans;
                                    const presultArr = Object.keys(presults).map((key) => presults[key]);

                                    setTotal(result.data?.total || 0);

                                    setPresentedLoans(presultArr);

                                    const initializedRows = resultArr.map(item => ({
                                        loanID:item.loanID,
                                        leadId:item.leadId,
                                        bulk_selected: false,
                                        bulk_amount:
                                        item.PendingAmount !== '' && Number(item.PendingAmount) < Number(item.EMI)
                                          ? item.PendingAmount
                                          : item.EMI,
                                      }));
                                      setRows(initializedRows);
                                } else {
                                    setPreloaderStatus(false);
                                    setBusinessDoneLoans([]);
                                    setPresentedLoans([]);
                                }
                            }).catch((error) => {
                                setPreloaderStatus(false);
                                console.error("Promise rejected -  getBusinessDoneLoansData:", error);
                            });
                        } else {
                            setPreloaderStatus(false);
                            toast.error(result.data.message, {
                                position: "top-right",
                            });
                        }
                    }).catch((error) => {
                        setPreloaderStatus(false);
                        console.error("Promise rejected -  setBeatPlanStatus: ", error);
                    });
                }

                setBeatPlanLocation({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude
                });
            }, (error) => {
                toast.error('Error getting location:', error, {
                    position: "top-right",
                });
            });
        } else {
            toast.error("Geolocation is not supported by this browser.", {
                position: "top-right",
            });
        }
    }

    useEffect(() => {
        if (cronRunDateArr.length > 0) {
            setActiveLoanTab(cronRunDateArr.length - 1);
        }
    }, [cronRunDateArr, setActiveLoanTab]);

    const goBackBtn = (event) => {
        
        setLoanDetailStatus(false);
        setAuditAllLoansButtonStatus(false);
        const url = `/dashboard/enach-transaction-scheduling-v2`;
       // window.open(url, '_self');
        navigate(url); 
      };

      const goBackBtnFromAuditAllLoans = (page = 1) => {

        setPreloaderStatus(true);
        setAuditAllLoansButtonStatus(false);
        setCronRunDateArr([]);
        setBusinessDoneLoans([]);
        setLoanDetailsEMIS([]);
        setBusinessDoneLoan([]);
        setPresentedLoans([]);
        
        const start = (page - 1) * RECORDS_PER_PAGE;

     //   alert(start);

        const params = { 'start': start, 'length': RECORDS_PER_PAGE, 'keyword' : keyword , 'isENACHRegistrationChecked':isENACHRegistrationChecked,'brief' : 'view_transaction_scheduling', 'filterDate' : selectedDate , 'partialAmount' : partialAmount, 'partialDebitDate' : partialDebitDate , 'bankDebitDate' : bankDebitDate, 'isENACHViewAllChecked':isENACHViewAllChecked ,'isENACHViewManualChecked':isENACHViewManualChecked, 'pageAction': "ckers", 'version' : 'version_2' };
        const requestData = encryptData(params);
        const response = actions.getBusinessDoneLoansDataFleet(requestData, false);
        response.then((result) => {
            // console.log("Promise resolved -  getBusinessDoneLoansData:", result);
            if (result.data.success === 1) {
                setPreloaderStatus(false);
                reInitOpenEnachForm();   
                const results = result.data.data.all_business_done_loans;
                const resultArr = Object.keys(results).map((key) => results[key]);

                const presults = result.data.data.presented_loans;
                const presultArr = Object.keys(presults).map((key) => presults[key]);

                setTotal(result.data?.total || 0);
                
                setPresentedLoans(presultArr);

                setBusinessDoneLoans(resultArr);
                setLoanDetailsEMIS([]);
                setBusinessDoneLoan([]);

                const initializedRows = resultArr.map(item => ({
                    loanID:item.loanID,
                    leadId:item.leadId,
                    bulk_selected: false,
                    bulk_amount:
                    item.PendingAmount !== '' && Number(item.PendingAmount) < Number(item.EMI)
                        ? item.PendingAmount
                        : item.EMI,
                  }));
                  setRows(initializedRows);
            } else {
                setPreloaderStatus(false);
                setBusinessDoneLoans([]);
                setLoanDetailsEMIS([]);
                setBusinessDoneLoan([]);
                setPresentedLoans([]);
            }

           
        }).catch((error) => {
            setPreloaderStatus(false);
            console.error("Promise rejected -  getBusinessDoneLoansData:", error);
        });
    };

      const viewDetails = (record) => {
        setLoanDetailsEMIS([]);
        setBusinessDoneLoan([]); 
        setLoanID(record.id); 
        setLoanDetailStatus(true);
        console.log("RepaymentSchedules = ",record.RepaymentSchedules);
        if (record && Object.prototype.hasOwnProperty.call(record, 'RepaymentSchedules')) {
            setLoanDetailsEMIS(record.RepaymentSchedules);
        }
        setBusinessDoneLoan(record);
      };

      const moneyFormatIndia = (number) => {
        if (number !== undefined && number !== null && !Number.isNaN(Number(number))) {
            number = parseFloat(number).toFixed(2);  // Ensure two decimal places
    
            const [integerPart, decimalPart] = number.split('.');
    
            const lastThreeDigits = integerPart.slice(-3);
            const otherDigits = integerPart.slice(0, -3);
    
            let formattedIntegerPart;
            if (otherDigits !== '') {
                formattedIntegerPart = `${otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ',')},${lastThreeDigits}`;
            } else {
                formattedIntegerPart = lastThreeDigits;
            }
    
            return `${formattedIntegerPart}.${decimalPart}`;
        }
    
        return '0.00';  // Default return value for invalid inputs
    };
    
    const formatDateForValue = (date) => {
        if (!date || Number.isNaN(new Date(date).getTime())) {
            return '';  // Return an empty string for invalid or empty dates
        }
    
        const newDate = new Date(date);
        const year = newDate.getFullYear();
        const month = String(newDate.getMonth() + 1).padStart(2, '0');
        const day = String(newDate.getDate()).padStart(2, '0');
    
        return `${day}-${month}-${year}`;
    };

   
    const columns = [
       

       /* {
            name: '',
           
            cell: row => (row.transaction_scheduling_data?.LatestEnachTransactionSchedulingStatus !== 'Success' && row.transaction_scheduling_data?.LatestEnachTransactionSchedulingStatus !== 'Initiated') ? (
                <input
                type="checkbox"
                checked={selectedRows.includes(row.loanID)}
                onChange={() => handleCheckboxChange(row.loanID)}
              />
            ) : null,  // Don't display checkbox if condition is not met

            width: '60px', // Adjust width of checkbox column if needed
          }, */

          {
            name: '',
           
            cell: row => (row.transaction_scheduling_data?.LatestEnachTransactionSchedulingStatus !== '' ) ? (
                <div>
                <div>
                <input
                type="checkbox"
                checked={selectedRows.includes(row.loanID)}
                onChange={() => handleCheckboxChange(row.loanID)}
              />
                </div>
              {row.transaction_scheduling_data?.totalPresentedNoInCurrentMonth > 0 && (
                <>
                <div className="text-success"><br/>
                    <NavLink to={`/dashboard/enach-transaction-scheduling-v2/${btoa(String(row.loanID))}/${btoa(String(row.AgreementNo))}/presented`} style={{ color: "green" }}>
                        Presented Counts - {row.transaction_scheduling_data?.totalPresentedNoInCurrentMonth}
                    </NavLink>
                    </div>
                </>
              )}

              <div>
                Proposed Amount : {row?.enach_registration_sms_info?.proposed_amount}<br/>
                EMI Amount : {moneyFormatIndia(row.EMI)}<br/>
              </div>
              <br />
                <input
                    type="number"
                    placeholder="Enter amount"
                    className="form-control mb-2"
                    value={
                        rows.find(item => item.loanID === row.loanID)?.bulk_amount || 0                      }
                    onChange={(e) => handleAmountChange(row.loanID, e.target.value)}
                    disabled={!selectedRows.includes(row.loanID)}
                />
              </div>
            ) : null,  // Don't display checkbox if condition is not met

            width: '200px', // Adjust width of checkbox column if needed
          },
        {
            name: 'Agreement No',
            selector: row => row.AgreementNo,
            sortable: true,
        },
        {
            name: 'CIFID',
            selector: row => row.CIFId,
            sortable: true,
        },
        
        {
            name: 'Customer Name',
            selector: row => row.CustomerName,
            sortable: true,
        },
        {
            name: 'Customer No',
            selector: row => row.CustomerNo,
            sortable: true,
        },

        {
            name: 'E-Nach Status',
            selector: row => row.LatestEnachRegistrationStatus,
            sortable: true,
            cell: row => (
                <span
                    style={{
                        color: row.LatestEnachRegistrationStatus === 'Success' ? 'green' :
                               (row.LatestEnachRegistrationStatus  === 'Aborted' ) ? 'orange' : 'red'
                    }}
                >
                    {row.LatestEnachRegistrationStatus}
                </span>
            ),
        },
        {
            name: 'Scheduling Status',
            selector: row => row.transaction_scheduling_data?.LatestEnachTransactionSchedulingStatus || 'N/A',
            sortable: true,
            cell: row => (
                <span
                    style={{
                        color: (row.transaction_scheduling_data?.LatestEnachTransactionSchedulingMessage === 'S') ? 'green' :
                               (row.transaction_scheduling_data?.LatestEnachTransactionSchedulingMessage  === 'I') ? 'orange' : 'red'
                    }}
                >
                    {
                    row.transaction_scheduling_data?.LatestEnachTransactionSchedulingMessage === 'F'
                        ? 'Failed'
                        : row.transaction_scheduling_data?.LatestEnachTransactionSchedulingStatus || 'N/A'
                    } 
                </span>
            ),
        },


        {
            name: 'Scheduling Successful',
            selector: row => row.transaction_verification_data?.LatestEnachTransactionVerificationStatus || 'N/A',
            sortable: true,
            cell: row => (
                
                
                 <span
                 style={{
                     color: (row.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'S') ? 'green' :
                            (row.transaction_verification_data?.LatestEnachTransactionVerificationMessage  === 'I') ? 'orange' : 'red'
                 }}
             >
                 {
                 row.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'F'
                     ? 'Failed'
                     : row.transaction_verification_data?.LatestEnachTransactionVerificationStatus || 'N/A'
                 } 
             </span>
            ),
        },
        
        {
            name: 'First Debit Date',
            selector: row => row.enach_registration_sms_info.proposed_debit_date,
            sortable: true,
            cell: row => (
                <span>
                    {formatDateForValue(row.enach_registration_sms_info.proposed_debit_date)}
                </span>
            ),
        },

        {
            name: 'UMRN',
            selector: row => row.UMRNNumber,
            sortable: true,
            cell: row => (
                <span>
                    {row.UMRNNumber}
                </span>
            ),
        },


        {
            name: 'Logs',
            cell: row => (
              <div className="btn-group dropstart" title="View Details">
                <NavLink to={`/dashboard/enach-transaction-scheduling-v2/${btoa(String(row.loanID))}/${btoa(String(row.AgreementNo))}`}>
                  <i className="bi bi-eye" style={{ color: "black" }} />
                </NavLink> 
              </div>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
          },
         
    ];

    // Conditional row styles to change text color
        const conditionalRowStyles = [
            {
            when: row => row.LatestEnachRegistrationStatus === 'Success-',   
            style: {
                color: 'green',
            },
            },
            {
            when: row => row.LatestEnachRegistrationStatus === 'Aborted-',  
            style: {
                color: 'red',
            },
            },
            {
            when: row => row.LatestEnachRegistrationStatus === 'Failed-',  
            style: {
                color: 'red',
            },
            },
        ];

    const ExpandedComponent = ({ data }) => (
        <div className='row px-2 py-2'>

        {data && Object.prototype.hasOwnProperty.call(data, 'enach_registration_sms_info') && (
            <div className="col-md-6" >
                <p>
                <strong>E-NACH Proposed Amount : </strong> 
                <span className="text-success">{data.enach_registration_sms_info.proposed_amount}
                </span></p>
            </div>
            )}

           {data && Object.prototype.hasOwnProperty.call(data, 'enach_registration_sms_info') && (
            <div className="col-md-6" >
                <p>
                <strong>E-NACH Proposed Debit Date : </strong> 
                <span className="text-success">{formatDateForValue(data.enach_registration_sms_info.proposed_debit_date)}</span>
                </p>
            </div>
            )} 

            <div className="col-md-6"><p><strong>Sanction Date : </strong> {formatDateForValue(data.dateOfSanction)}</p></div>
            <div className="col-md-6"><p><strong>Disbusment Date : </strong> {formatDateForValue(data.dateOfDisbursement)}</p></div>
            <div className="col-md-6"><p><strong>Finance Id : </strong> {data.FinanceId}</p></div>
            <div className="col-md-6"><p><strong>Company Role Id : </strong> {data.CompanyRoleId} </p> </div>
            <div className="col-md-6"><p><strong>Loan Type : </strong> {data.LoanType} </p> </div>
            <div className="col-md-6"><p><strong>Asset Id : </strong> {data.AssetId} </p> </div>
            <div className="col-md-6"><p><strong>Total Amount : </strong> {moneyFormatIndia(data.TotalAmount)} </p> </div>
            <div className="col-md-6"><p><strong>Duration : </strong> {data.Duration} </p> </div>
            <div className="col-md-6"><p><strong>Interest (%) : </strong> {data.Interest} </p> </div>
            <div className="col-md-6"><p><strong>EMI : </strong> {moneyFormatIndia(data.EMI)} </p> </div>
            <div className="col-md-6"><p><strong>Yearly Interest (%) : </strong> {data.YearlyInterest} </p> </div>
            <div className="col-md-6"><p><strong>Start Date : </strong> {formatDateForValue(data.StartDate)} </p> </div>
            <div className="col-md-6"><p><strong>Loan Closure Date : </strong> {formatDateForValue(data.LoanClosureDate)} </p> </div>
            <div className="col-md-6"><p><strong>DPD Days : </strong> {data.DPDDays} </p> </div>
            <div className="col-md-6"><p><strong>Future Value : </strong> {data.FutureValue} </p> </div>
            <div className="col-md-6"><p><strong>Insurance Amount : </strong> {moneyFormatIndia(data.InsuranceAmount)} </p> </div>
            <div className="col-md-6"><p><strong>Insurance Duration : </strong> {data.InsuranceDuration} </p> </div>
            <div className="col-md-6"><p><strong>Indicative ROI : </strong> {data.IndicativeROI} </p> </div>
            <div className="col-md-6"><p><strong>Send SMS : </strong> {data.SendSMS} </p> </div>
            <div className="col-md-6"><p><strong>Scheme Id : </strong> {data.SchemeId} </p> </div>
            <div className="col-md-6"><p><strong>EMIType Id : </strong> {data.EMITypeId} </p> </div>
            <div className="col-md-6"><p><strong>LPC Amount : </strong> {moneyFormatIndia(data.LPCAmount)} </p> </div>
            <div className="col-md-6"><p><strong>LPC Type : </strong> {data.LPCType} </p> </div>
            <div className="col-md-6"><p><strong>LPC Interest : </strong> {data.LPCInterest} </p> </div>
            <div className="col-md-6"><p><strong>Installment Type Id : </strong> {data.InstallmentTypeId} </p> </div>
            <div className="col-md-6"><p><strong>ROI Duration : </strong> {data.ROIDuration} </p> </div>
            <div className="col-md-6"><p><strong>Sub Loan Type For PL : </strong> {data.SubLoanTypeForPL} </p> </div>
            <div className="col-md-6"><p><strong>Loan Category : </strong> {data.LoanCategory} </p> </div>
            <div className="col-md-6"><p><strong>Down Payment : </strong> {moneyFormatIndia(data.DownPayment)} </p> </div>
            <div className="col-md-6"><p><strong>Advance EMI : </strong> {data.AdvanceEMI} </p> </div>
            <div className="col-md-6"><p><strong>Loan Segment Id : </strong> {data.LoanSegmentId} </p> </div>
            <div className="col-md-6"><p><strong>UTR No : </strong> {data.UTRNo} </p> </div>
            <div className="col-md-6"><p><strong>Disbursement Status : </strong> {data.DisbursementStatus} </p> </div>
            <div className="col-md-6"><p><strong>Nach StatusId : </strong> {data.NachStatusId} </p> </div>
            <div className="col-md-6"><p><strong>UMRN Number : </strong> {data.UMRNNumber} </p> </div>
            <div className="col-md-6"><p><strong>Status Id : </strong> {data.StatusId} </p> </div>
            <div className="col-md-6"><p><strong>EMI Start Date : </strong> {formatDateForValue(data.EMIStartDate)} </p> </div>
            <div className="col-md-6"><p><strong>EMI End Date : </strong> {formatDateForValue(data.EMIEndDate)} </p> </div>
            <div className="col-md-6"><p><strong>Next Payment Date : </strong> {formatDateForValue(data.NextPaymentDate)} </p> </div>
            <div className="col-md-6"><p><strong>Next EMI Due Date : </strong> {formatDateForValue(data.NextEMIDueDate)} </p> </div>
            <div className="col-md-6"><p><strong>Mode Of RePayment Id : </strong> {data.ModeOfRePaymentId} </p> </div>
            <div className="col-md-6"><p><strong>No Of Paid EMI : </strong> {data.NoOfPaidEMI} </p> </div>
            <div className="col-md-6"><p><strong>Total Received Amt : </strong> {moneyFormatIndia(data.TotalReceivedAmt)} </p> </div>
            <div className="col-md-6"><p><strong>Total Principle Recvd : </strong> {moneyFormatIndia(data.TotalPrincipleRecvd)} </p> </div>
            <div className="col-md-6"><p><strong>Total Interest Paid : </strong> {moneyFormatIndia(data.TotalInterestPaid)} </p> </div>
            <div className="col-md-6"><p><strong>EMI DueCount : </strong> {data.EMIDueCount} </p> </div>
            <div className="col-md-6"><p><strong>Total Principal Due : </strong> {moneyFormatIndia(data.TotalPrincipalDue)} </p> </div>
            <div className="col-md-6"><p><strong>Total Interest Due : </strong> {moneyFormatIndia(data.TotalInterestDue)} </p> </div>
            <div className="col-md-6"><p><strong>Total VAS Dues : </strong> {moneyFormatIndia(data.TotalVASDues)} </p> </div>
            <div className="col-md-6"><p><strong>Total Due Amount (Installment Dues (C)) : </strong> {moneyFormatIndia(data.TotalDueAmount)} </p> </div>
            <div className="col-md-6"><p><strong>LPI Dues : </strong> {moneyFormatIndia(data.LPIDues)} </p> </div>
            <div className="col-md-6"><p><strong>Default Chrages : </strong> {moneyFormatIndia(data.DefaultChrages)} </p> </div>
            <div className="col-md-6"><p><strong>Total EMI Overdue Amount : </strong> {moneyFormatIndia(data.TotalEMIOverdueAmount)} </p> </div>
            <div className="col-md-6"><p><strong>Total Loan Overdue Amount : </strong> {moneyFormatIndia(data.TotalLoanOverdueAmount)} </p> </div>
            <div className="col-md-6"><p><strong>Loan Total Due : </strong> {moneyFormatIndia(data.LoanTotalDue)} </p> </div>
            <div className="col-md-6"><p><strong>Last updated : </strong> {data.cronRunDate} </p> </div>
        </div>
    );

    const [open, setOpen] = React.useState(false);
    const btnOpenUploadMissingData = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
        setSelectedItrFiles([]); // Reset selected ITR files
    };

    const [openEnach, setOpenEnach] = React.useState(false);
    const btnOpenEnachData = () => setOpenEnach(true);
    const handleCloseEnach = () => {
        setOpenEnach(false); 
        setPartialAmount('');
        setPartialDebitDate('');
        setBankDebitDate('');
     };

    const [selectedItrFiles, setSelectedItrFiles] = useState([]);

    const handleItrFileChange = (e) => {
        const files = Array.from(e.target.files);
        const base64Files = [];

        files.forEach((file) => {
            const reader = new FileReader();
            reader.onload = (event) => {
                const base64Data = event.target.result;
                const fileName = file.name;
                base64Files.push({ file: base64Data, name: fileName });
                if (base64Files.length === files.length) {
                    setSelectedItrFiles(base64Files);
                }
            };
            reader.readAsDataURL(file);
        });
    };

    

    const handleFormSubmit = (data) => {

        if (!selectedItrFiles || selectedItrFiles.length === 0) {
            toast.error("No file has been selected.", {
                position: "top-right",
            });
        } else {

            const params = {"upload_file": selectedItrFiles };

            // setPreloaderStatus(true);
            const requestData = encryptData(params);
            const response = actions.uploadMissingData(requestData, navigate);

            response.then((result) => {
                // console.log("Promise resolved - uploadLeads form:", result); 
                if (result.data.success === 1) {
                    toast.success(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                    reset();
                    setOpen(false);
                    setSelectedItrFiles([]);
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                    setPreloaderStatus(false);
                }
            }).catch((error) => {
                toast.error(error, {
                    position: "top-right",
                });
            });
        }
    };

    const defaultQRCall = useCallback(async () => {

        if( !loadDefaultQR && totalOutstandingAmt > 0){
            const params = { 'amount':totalOutstandingAmt, "AgreementNo" : businessDoneLoan.AgreementNo };
            if (userId !== '') {
                params.user_id = userId;
            }
        
            setIntentUrl('');
            // console.log("form data = ", params);
            const requestData = encryptData(params);            
            try {
                const result = await actions.generateQRcode(requestData);
                setLoadDefaultQR(true);                
                if (result.data.success === 1) {
                    if (result.data.intent_url !== '') {
                        setIntentUrl(result.data.intent_url);
                        toast.success("QR code generated successfully.", {
                            position: "top-right",
                        });
                    } else {
                        toast.error("You can't generate QR code, Please try again!", {
                            position: "top-right",
                        });
                    }
                } else {
                    toast.error(result.data.message, {
                        position: "top-right",
                    });
                }
            } catch (error) {
                toast.error(error.message || "An error occurred", {
                    position: "top-right",
                });
            }
        }
    }, [userId, formValues, loadDefaultQR, totalOutstandingAmt]);
    
    useEffect(() => {
        if (!loadDefaultQR) {
         //  defaultQRCall();
        }
    }, [loadDefaultQR, defaultQRCall, totalOutstandingAmt]);

    
    const handleSubmitForm = (data) => {
        const params = { 'amount':  formValues.amount, "AgreementNo" : businessDoneLoan.AgreementNo };
        if (userId !== '') {
            params.user_id = userId;
        }
        setIntentUrl('');
        // console.log("form data = ", params);
        const requestData = encryptData(params);
        const response = actions.generateQRcode(requestData);
        response.then((result) => {
             if (result.data.success === 1) {
                if (result.data.intent_url !== '') {  
                    setIntentUrl(result.data.intent_url);  
                    toast.success("QR code generated sucessfully.", {
                        position: "top-right",
                    });
                } else {
                    toast.error("You can't generate QR code, Please try again!", {
                        position: "top-right",
                    });
                }
            } else {
                toast.error(result.data.message, {
                    position: "top-right",
                });
            }
        }).catch((error) => {
             toast.error(error, {
                position: "top-right",
            });
        });
    };   
    const handleChange = (e) => { 
       // setIntentUrl('');
        const { name, value } = e.target;      
        setFormValues({
            ...formValues,
            [name]: value,
        });         
    };

 
    const handleDateChange = (e) => {
        const fullDate = e.target.value; // YYYY-MM-DD
        alert(fullDate);
       // const [year, month, day] = fullDate.split('-');
       // setFilterdate(`${month}-${day}`); // Display only MM-DD

    };

    const handleBankDebitDateChange = (e) => {
        const selectedDate = e.target.value; // YYYY-MM-DD format

        if (!selectedDate) {
            setBankDebitDate('');
            return;
        }

        const selected = new Date(selectedDate);
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        // Get the day of the month
        const dayOfMonth = selected.getDate();

        // Get current month and year
        const currentMonth = today.getMonth();
        const currentYear = today.getFullYear();
        const selectedMonth = selected.getMonth();
        const selectedYear = selected.getFullYear();

        // Check if selected date is in the current month
        const isCurrentMonth = selectedMonth === currentMonth && selectedYear === currentYear;

        // Validation 1: Cannot select 1st, 2nd, 3rd, or 4th of the current month
          if (isCurrentMonth && dayOfMonth >= 1 && dayOfMonth <= 4) {
            toast.error("Cannot select 1st, 2nd, 3rd, or 4th of the current month.", {
                position: "top-right",
            });
            e.target.value = '';
            setBankDebitDate('');
            return;
        }   

        // Validation 2: Cannot select today's date
        if (selected.getTime() === today.getTime()) {
            toast.error("Cannot select today's date. Please select a future date.", {
                position: "top-right",
            });
            e.target.value = '';
            setBankDebitDate('');
            return;
        }  

        // Validation 3: Can only select future dates
        if (selected < today) {
            toast.error("Please select a future date only.", {
                position: "top-right",
            });
            e.target.value = '';
            setBankDebitDate('');
            return;
        }

        // Validation 4: Cannot select more than 3 days in the future
        const maxFutureDate = new Date(today);
        maxFutureDate.setDate(today.getDate() + 3);
        maxFutureDate.setHours(0, 0, 0, 0);
    
      /*  if (selected > maxFutureDate) {
            toast.error("Cannot select a date more than 2 days in the future.", {
                position: "top-right",
            });
            e.target.value = '';
            setBankDebitDate('');
            return;
        } */

        // If all validations pass, set the date
        setBankDebitDate(selectedDate);
    };

    // ready to run e-nach api for single record
    const handleFormSubmitEnach = (data) => {
        console.log("data = ", data)
        if (data.partial_enach_proposed_amount === '' || data.partial_debit_date === '') {
            toast.error("Please enter details.", {
                position: "top-right",
            });
        } else { 
            setPartialAmount(data.partial_enach_proposed_amount);
            setPartialDebitDate(data.partial_debit_date);
            setRunENACHTransactionsApis(true); 
        }
    };

    const btnSkipPartialPayment = (data) => {
        setPartialAmount('');
        setPartialDebitDate('');
        setRunENACHTransactionsApis(true); 
    };

    

    const exportEnachMandates = async (exportType = '') => {
        // Check if selected month is future
        if (isFutureMonth(selectedDate) || exportType === 'enach_report') {
            // Future month: Fetch all records first, then export
            setPreloaderStatus(true);

            try {
                const params = {
                    'start': '0',
                    'length': config.MAX_RECORDS,
                    'keyword': keyword,
                    'isENACHRegistrationChecked': isENACHRegistrationChecked,
                    'brief': 'view_transaction_scheduling',
                    'filterDate': selectedDate,
                    'partialAmount': partialAmount,
                    'partialDebitDate': partialDebitDate,   
                    'bankDebitDate': bankDebitDate,
                    'isENACHViewAllChecked': isENACHViewAllChecked,
                    'isENACHViewManualChecked': isENACHViewManualChecked,
                    'pageAction': "ckers",
                    "apiType": "download_report",
                    "currentPage" : currentPage, 'version' : 'version_2' 
                    
                };

                const requestData = encryptData(params);
                const response = await actions.getBusinessDoneLoansDataFleet(requestData, false);

                if (response.data.success === 1) {
                    const results = response.data.data.all_business_done_loans;
                    const allLoans = Object.keys(results).map((key) => results[key]);

                    // Get current date for Posting Date column
                    const currentDate = formatDateForValue(new Date());

                    const columnMapping = {
                        'AgreementNo': 'Loan No',
                        'LoanType': 'Loan Type',
                        'UMRNNumber': 'UMRN No',
                        'amount': 'Amount',
                        'posting_date': 'Posting Date',
                        'CustomerName': 'Customer Name',
                        'bank_account_no': 'Bank Account No',
                        'ifsc_code': 'IFSC Code',
                        'CustomerNo': 'Mobile No',
                        'ach_type': 'ACH Type',
                        'ach_agent': 'ACH Agent',
                        'bank_format': 'Bank Format',
                        'proposed_amount': 'Proposed Amount',
                        'EMI': 'Emi Amount'
                    };

                    const selectedColumns = Object.keys(columnMapping);
                    const filteredData = allLoans.map(loan => {
                        const filteredLoan = {};

                        if(loan !== undefined) {
                            selectedColumns.forEach(col => {
                                if (loan[col] !== undefined) {
                                    filteredLoan[columnMapping[col]] = loan[col];
                                } else if (col === 'proposed_amount') {
                                    filteredLoan[columnMapping[col]] = loan?.enach_registration_sms_info?.proposed_amount || '';
                                } else if (col === 'amount') {
                                    filteredLoan[columnMapping[col]] = loan.PendingAmount !== '' && Number(loan.PendingAmount) < Number(loan.EMI)
                                          ? loan.PendingAmount
                                          : loan.EMI;
                                } else if (col === 'posting_date') { 
                                    filteredLoan[columnMapping[col]] = selectedDate;
                                } else if (col === 'bank_account_no') {
                                    filteredLoan[columnMapping[col]] = '';
                                } else if (col === 'ifsc_code') {
                                    filteredLoan[columnMapping[col]] = '';
                                } else if (col === 'ach_type') {
                                    filteredLoan[columnMapping[col]] = 'eNACH';
                                } else if (col === 'ach_agent') {
                                    filteredLoan[columnMapping[col]] = 'Worldline';
                                } else if (col === 'bank_format') {
                                    filteredLoan[columnMapping[col]] = '';
                                }
                            });
                        }
                        return filteredLoan;
                    });

                    const ws = XLSX.utils.json_to_sheet(filteredData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, 'Data');
                    XLSX.writeFile(wb, 'Enach-report.xlsx');

                    setPreloaderStatus(false);
                    toast.success('Report exported successfully!', {
                        position: "top-right",
                    });
                } else {
                    setPreloaderStatus(false);
                    toast.error('Failed to fetch data for export', {
                        position: "top-right",
                    });
                }
            } catch (error) {
                setPreloaderStatus(false);
                toast.error('Error exporting report', {
                    position: "top-right",
                });
                console.error("Report export error:", error);
            }
        } else {
            // Current or past month: Fetch all records first, then export with filtering
            setPreloaderStatus(true);

            try {
                const params = {
                    'start': '0',
                    'length': config.MAX_RECORDS,
                    'keyword': keyword,
                    'isENACHRegistrationChecked': isENACHRegistrationChecked,
                    'brief': 'view_transaction_scheduling',
                    'filterDate': selectedDate,
                    'partialAmount': partialAmount,
                    'partialDebitDate': partialDebitDate, 
                    'bankDebitDate': bankDebitDate,
                    'isENACHViewAllChecked': isENACHViewAllChecked,
                    'isENACHViewManualChecked': isENACHViewManualChecked,
                    'pageAction': "ckers",
                    "apiType": "download_report",
                    "currentPage" : currentPage, 'version' : 'version_2' 
                };

                const requestData = encryptData(params);
                const response = await actions.getBusinessDoneLoansDataFleet(requestData, false);

                if (response.data.success === 1) {
                    const results = response.data.data.all_business_done_loans;
                    const allLoans = Object.keys(results).map((key) => results[key]);

                    let dataToExport = allLoans;

                    if (exportFilter === 'Success') {
                        dataToExport = allLoans.filter(loan =>
                            loan?.transaction_verification_data?.LatestEnachTransactionVerificationStatus?.toLowerCase() === 'success' ||
                            loan?.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'S'
                        );
                    }

                    if (exportFilter === 'Failed') {
                        dataToExport = allLoans.filter(loan =>
                            loan?.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'F' ||
                            loan?.transaction_verification_data?.LatestEnachTransactionVerificationStatus?.toLowerCase() === 'failed'
                        );
                    }

                    const columnMapping = {
                        'CustomerName': 'Customer Name',
                        'AgreementNo': 'AgreementNo',
                        'proposed_debit_date': 'Push Date (Proposed debit date)',
                        'date_of_clearance': 'Date Of Clearence',
                        'partial_amount': 'Amount',
                        'status': 'Status'
                    }; 
                   
                    setTotal(dataToExport.length || 0);

                    const selectedColumns = Object.keys(columnMapping);
                    const filteredData = dataToExport.map(loan => {
                        const filteredLoan = {};

                        if(loan !== undefined) {
                            selectedColumns.forEach(col => {
                                if (loan[col] !== undefined) {
                                    filteredLoan[columnMapping[col]] = loan[col];
                                } else if (col === 'proposed_debit_date') {
                                    filteredLoan[columnMapping[col]] = formatDateForValue(loan?.enach_registration_sms_info?.proposed_debit_date) || '';
                                } else if (col === 'date_of_clearance') {
                                    filteredLoan[columnMapping[col]] = formatDateForValue(loan?.dateOfClearance) || '';
                                } else if (col === 'partial_amount') {
                                    filteredLoan[columnMapping[col]] = loan?.enach_registration_sms_info?.proposed_amount || loan?.EMI || '';
                                } else if (col === 'status') {
                                    const status = loan?.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'F'
                                        ? 'Failed'
                                        : loan?.transaction_verification_data?.LatestEnachTransactionVerificationMessage === 'S'
                                            ? 'Success'
                                            : loan?.transaction_verification_data?.LatestEnachTransactionVerificationStatus || 'N/A';
                                    filteredLoan[columnMapping[col]] = status;
                                }
                            });
                        }
                        return filteredLoan;
                    });

                    const ws = XLSX.utils.json_to_sheet(filteredData);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, 'Data');
                    XLSX.writeFile(wb, 'Enach-report.xlsx');

                    setPreloaderStatus(false);
                    toast.success('Report exported successfully!', {
                        position: "top-right",
                    });
                    
                    onSubmit();
                } else {
                    setPreloaderStatus(false);
                    toast.error('Failed to fetch data for export', {
                        position: "top-right",
                    });
                }
            } catch (error) {
                setPreloaderStatus(false);
                toast.error('Error exporting report', {
                    position: "top-right",
                });
                console.error("Export error:", error);
            }
        }
    };

      
        const exportBulkPreview = async () => {    
             setPreloaderStatus(true);

            try {
                const params = {
                    'start': '0',
                    'length': config.MAX_RECORDS,
                    'keyword': keyword,
                    'isENACHRegistrationChecked': isENACHRegistrationChecked,
                    'brief': 'view_transaction_scheduling',
                    'filterDate': selectedDate,
                    'partialAmount': partialAmount,
                    'partialDebitDate': partialDebitDate, 
                    'bankDebitDate': bankDebitDate,
                    'isENACHViewAllChecked': isENACHViewAllChecked,
                    'isENACHViewManualChecked': isENACHViewManualChecked,
                    'pageAction': "ckers", 'version' : 'version_2' 
                };

                const requestData = encryptData(params);
                const response = await actions.getBusinessDoneLoansDataFleet(requestData, false);

                if (response.data.success === 1) {
                    const results = response.data.data.all_business_done_loans;
                    const allLoans = Object.keys(results).map((key) => results[key]);

                    
                setTotal(allLoans.length || 0);
                const columnMapping = {
                    'CustomerName': 'Customer Name',
                    'AgreementNo': 'AgreementNo',
                    'proposed_amount': 'Proposed Amount',
                    'partial_amount': 'Presenting Amount'
                };  
            const selectedColumns = Object.keys(columnMapping);
            const filteredData = allLoans.map(loan => {
                const filteredLoan = {};
                const presentedRow = rows.find(item => item.loanID === loan?.loanID);
                const presentedAmount = presentedRow ? presentedRow.bulk_amount : null;

                if(loan !== undefined) {
                selectedColumns.forEach(col => {
                    if (loan[col] !== undefined) {
                            filteredLoan[columnMapping[col]] = loan[col];
                    } else if (col === 'proposed_amount') {
                        filteredLoan[columnMapping[col]] = loan?.enach_registration_sms_info?.proposed_amount || '';
                     } else if (col === 'partial_amount') {
                        filteredLoan[columnMapping[col]] = presentedAmount || '';    
                    }  
                });
            }


                return filteredLoan;
            });
            const ws = XLSX.utils.json_to_sheet(filteredData);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Data');
            XLSX.writeFile(wb, 'Enach-Preview-report.xlsx');

             setPreloaderStatus(false);
            toast.success('Report exported successfully!', {
                position: "top-right",
            });

             } else {
                setPreloaderStatus(false);
                toast.error('Failed to fetch data for export', {
                    position: "top-right",
                });
            }

            } catch (error) {
                setPreloaderStatus(false);
                toast.error('Error exporting report', {
                    position: "top-right",
                });
                console.error("Export error:", error);
            }
        };

    if (!userHasPermission) {
        // Redirect or render an access denied message
        return <AccessDenied />;
    }

   
    return (
        <>  
            <Helmet>
                <title>View Transaction Scheduling | Ckers</title>
            </Helmet>

            <Container>
                
                <div id='main-wrap'  className={loanDetailStatus ? "d-none mb-3 mmt-7 filter" : "mb-3 mmt-7 filter"}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className='row mx-0'>
                        <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="start-date">
                                        <span>Select Month </span>
                                        <DatePicker
                                            selected={selectedDate}
                                            onChange={(date) => setSelectedDate(date)}
                                            dateFormat="MM-yyyy"          
                                            showMonthYearPicker    
                                            placeholderText="MM-YYYY"    
                                            className="form-control" 
                                        />
                                        
                                    </label> 
                                </div>
                            </div>
                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>Keyword</span>
                                        <input type='text' name='keyword' id='keyword' className='form-control'{...register('keyword')} placeholder="Enter your value here..." onChange={handleKeywordChange}/>
                                    </label>
                                </div>
                            </div>

                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>View All</span>
                                        <input type='checkbox' name='view_all' id='view_all' {...register('view_all')} onChange={handleENACHViewAll}/>
                                    </label>
                                </div>
                            </div>

                            <div className='col'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>Manual Loans</span>
                                        <input type='checkbox' name='manual_loans' id='manual_loans' {...register('manual_loans')} onChange={handleENACHViewManual}/>
                                    </label>
                                </div>
                            </div>

                            {!isFutureMonth(selectedDate) && (
                            <div className='col hide'>
                                <div className='form-group'>
                                    <label htmlFor="status_filter">
                                        <span>Status</span>
                                        <select
                                            className="form-control"
                                            value={exportFilter}
                                            onChange={(e) => setExportFilter(e.target.value)}
                                        >
                                            <option value="All">All</option>
                                            <option value="Success">Success</option>
                                            <option value="Failed">Failed</option>
                                        </select>
                                    </label>
                                </div>
                            </div>
                            )}

                            <div className='col d-none'>
                                <div className='form-group'>
                                    <label htmlFor="keyword">
                                        <span>E-NACH Done In LMS</span>
                                        <input type='checkbox' name='enach_registration' id='enach_registration' {...register('enach_registration')} onChange={handleENACHRegistrationChange}/>
                                    </label>
                                </div>
                            </div>

                            <div className='col'>
                                <div className='form-group mb-2'>
                                    <span className='d-block'>&nbsp;</span>
                                    <button className='btn btn-primary'>Search</button>
                                </div>

                                
                            </div>

                            <div className='col'>
                                <div className='form-group mb-2 '>
                                    <span className='d-block'>&nbsp;</span>
                                    <button onClick={btnRunENACHTransactions}
                                        type="button"
                                        className="btn btn-success text-white hide"
                                        title="Superadmin and Ajay Grover can schedule multiple transactions within a single month"
                                    >
                                        Run E-NACH Transactions
                                    </button> 

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="bank_debit_date">
                                                <span>Debit Date </span>
                                                <input
                                                    type='date'
                                                    id='bank_debit_date'
                                                    name='bank_debit_date'
                                                    className='form-control'
                                                    {...register('bank_debit_date')}
                                                    onChange={handleBankDebitDateChange}
                                                    min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]}
                                                    max={new Date(new Date().setDate(new Date().getDate() + 2)).toISOString().split('T')[0]}
                                                    value={bankDebitDate}
                                                />
                                            </label>
                                        </div>
                                    </div>


                                    {  ( selectedRows.length >0 && !disableBtn ) && (
                                    <button onClick={btnRunENACHBULKTransactions}
                                        type="button"
                                        className="btn btn-primary text-white"
                                        title="Superadmin and Ajay Grover can schedule multiple transactions within a single month"
                                        style={{ position: 'fixed', right:"30px" , zIndex:"99999", top:'130px'}} 
                                    >
                                        Run E-NACH BULK Transactions
                                    </button>
                                    )}
                                </div>

                                <div className='form-group mb-2 d-none'>
                                    <span className='d-block'>&nbsp;</span>
                                    <button onClick={btnOpenUploadMissingData}
                                        type="button"
                                        className="btn btn-info text-white"
                                    >
                                        Upload Missing Data
                                    </button> 
                                </div>

                                <div className='form-group mb-2 d-none'> 
                                     <span className='d-block'>&nbsp;</span>
                                    <NavLink to={`/dashboard/enach-transaction-scheduling-v2`}>
                                    <button
                                        type="button"
                                        className="btn btn-primary text-white"
                                    >
                                        View Transaction Scheduling
                                    </button>
                                    </NavLink>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end">
                                <div className={auditAllLoansButtonStatus ? "col" : "col d-none"}>
                                    <button onClick={goBackBtnFromAuditAllLoans}
                                        type="button"
                                        className="badge text-bg-success text-white"
                                        title="go back 2"
                                    >
                                        Go Back 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div id="main-wrap">
                    <div className="row justify-content-between">
                         

                        <div className="col-md-7">
                            <Typography className="line-initial" variant="h4" sx={{ mb: 0 }}>
                            Transaction Scheduling Logs {businessDoneLoan.AgreementNo !== undefined && (
                                    <>
                                        ({businessDoneLoan.AgreementNo})
                                    </>
                                )}
                            </Typography> 

                            {/* Pagination */}

                        { !auditAllLoansButtonStatus  && (
                        <div style={{ marginTop: '10px', display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <button
                            disabled={currentPage === 1}
                            onClick={() => setCurrentPage(currentPage - 1)}
                            style={{ padding: '5px 10px', cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                        >
                            Prev
                        </button>

                        {/* Page Numbers */}
                        {(() => {
                            const pageNumbers = [];

                            // Show all pages
                            for (let i = 1; i <= totalPages; i += 1) {
                                pageNumbers.push(
                                    <button
                                        key={i}
                                        onClick={() => setCurrentPage(i)}
                                        style={{
                                            padding: '5px 10px',
                                            margin: '0 2px',
                                            backgroundColor: currentPage === i ? '#007bff' : '#fff',
                                            color: currentPage === i ? '#fff' : '#000',
                                            border: '1px solid #ddd',
                                            cursor: 'pointer',
                                            fontWeight: currentPage === i ? 'bold' : 'normal',
                                            minWidth: '35px'
                                        }}
                                    >
                                        {i}
                                    </button>
                                );
                            }

                            return pageNumbers;
                        })()}

                        <button
                            disabled={currentPage === totalPages}
                            onClick={() => setCurrentPage(currentPage + 1)}
                            style={{ padding: '5px 10px', cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                        >
                            Next
                        </button>
                        </div>
    )}
                            
                            <div className={auditAllLoansButtonStatus ? "d-none" : "m-1 d-none"}>
                                <button className="btn btn-info text-white" onClick={() => auditAllLoansButton()}>
                                    AUDIT ALL LOANS
                                </button>
                            </div>
                        </div>


                        <div className='col-md-5 text-end ps-lg-5'>                            
                        {(!loanDetailStatus) && (
                            <>
                            <div className="form-group d-flex justify-content-end align-items-center">
                                <label htmlFor="search" className='w-100 d-none'>
                                    {/* Search : */}
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder=""
                                        id="search"
                                        value={searchQuery}
                                        onChange={handleSearchChange}
                                    />
                                </label>
                                <button className="btn btn-info text-white ms-3 d-none" onClick={() => exportLoansReport()}>
                                    Export
                                </button>
                                
                            </div>
                            <div className="float-left mb-2"><b>Total Records : {total}</b></div> 
                            </>
                        )}

                        {(loanDetailStatus) && ( 
                            <div>                      
                                <button onClick={goBackBtn} 
                                    type="button"
                                    className= "badge text-bg-success text-white float-right"
                                    title="go back 1"> 
                                Go Back
                                </button> 
                                </div>                                
                            )}
                           
                        </div>
                        
                        {(!loanDetailStatus) && (
                            <>
                                <div className='row'>
                                    <div className="col-md-12 mt-1">
                                        <div className="tabs">
                                            {cronRunDateArr.map((tab, index) => (
                                                <button
                                                    key={index}
                                                    className={activeLoanTab === index ? 'btn active activTab btn-primary' : 'btn'}
                                                    onClick={() => handleTabClick(index)}
                                                >
                                                    {tab.formatted_cron_run_date}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </>
                        )}
                           
                    </div>
                    
                     

                    {(!loanDetailStatus) ? (
                        <>
                         {(filteredBusinessDoneLoans.length >0) && (
                        <div>
                            <button className="btn btn-warning text-white" onClick={handleSelectAll}>Select All</button>&nbsp;

                            <button className="btn btn-danger text-white" onClick={handleUnselectAll}>Unselect All</button>

                            {  ( selectedRows.length >0 ) && (
                            <button className="btn btn-primary text-white ms-3" onClick={() => exportBulkPreview()} style={{ textAlign: 'end', float:"right" }}>BULK  Preview</button>
                            )}

                            {!isFutureMonth(selectedDate) && (
                                <select
                                    className="form-select d-inline-block w-auto ms-3"
                                    value={exportFilter}
                                    onChange={(e) => setExportFilter(e.target.value)}
                                    style={{  float:"right" }}
                                >
                                    <option value="All">All</option>
                                    <option value="Success">Success</option>
                                    <option value="Failed">Failed</option>
                                </select>
                            )}

                            {!isFutureMonth(selectedDate) && (
                              <> 
                            <button
                                className="btn btn-info text-white ms-3"
                                onClick={() => exportEnachMandates()}
                                style={{ textAlign: 'end', float:"right" }}
                            >
                                {isFutureMonth(selectedDate)
                                    ? 'Download Report'
                                    : exportFilter === 'Success'
                                        ? 'Download Success Transactions'
                                        : exportFilter === 'Failed'
                                            ? 'Download Failed Transactions'
                                            : 'Download Transactions Status'
                                }
                            </button>
                            </>
                             )}
                            
                             
                            <button
                                className="btn btn-warning text-white ms-3"
                                onClick={() => exportEnachMandates('enach_report')}
                                style={{ textAlign: 'end', float:"right" }}
                            >
                                Download Report
                            </button>
                             
                        </div> )}
                       
                        <DataTable
                            // title="My DataTable with Expandable Rows"
                            columns={columns}
                            data={filteredBusinessDoneLoans}
                            expandableRows
                            expandableRowsComponent={ExpandedComponent}
                            conditionalRowStyles={conditionalRowStyles}
                            // pagination
                        />
                        </>
                    ) : (
                        <>
                        <div className="mt-4">

                        <div className="row">

                        <div className="col-md-12 mt-4">  
                            <div className="tabs">
                                {reportName !=='' && versioningLoans.map((tab, index) => (
                                 
                                <button                                   
                                    className={activeTab === index ? 'btn active activTab btn-primary' : 'btn'}
                                    onClick={() => setActiveTab(index)}
                                >
                                    {tab.formated_cron_run_date}
                                </button>
                                 
                                ))}
                            </div>
                            </div>
                           <div className="col-md-12">   
                            <div className="tab-content">

                            {versioningLoans.map((vitem, vindex) => { 
                                return (
                                    <> 
                                        <div  key={vindex} className={activeTab === vindex ? 'width100' : 'width100 d-none'}> 
                                            <LogsVersioning vitem={vitem} />
                                        </div>
                                     </>
                                );
                                })}
                            </div> 
                            </div> 
                            </div>
                        </div>
                    </>)}

                     
                </div>

                {preloaderStatus && <Loader />}
            </Container>

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Upload Additional Data</h4>
                        <Button onClick={handleClose} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmit)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="itr_file">
                                                <span>File Upload <a style={{ color: "red" }}>*</a></span>
                                                <input
                                                    type='file'
                                                    id='itr_file'
                                                    name='itr_file'
                                                    className='form-control'
                                                    {...register('itr_file')}
                                                    onChange={handleItrFileChange}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2"
                                            >
                                                Submit
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>


            <Modal
                open={openEnach}
                onClose={handleCloseEnach}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div className='modal-custom rounded'>
                    <div className='modal-head'>
                        <h4 id="modal-title">Partial Payment</h4>
                        <Button onClick={handleCloseEnach} color="primary" className=' btn'>
                            <i className="bi bi-x">&nbsp;</i>
                        </Button>
                    </div>
                    
                    <div className='modal-body'>
                        <div>
                            <form onSubmit={handleSubmit(handleFormSubmitEnach)} encType="multipart/form-data">
                                <div className="row mx-0">
                                    <div className="col-md-6 px-0">
                                        <div className="form-group">
                                            <label htmlFor="partial_enach_proposed_amount">
                                                <span>Amount</span>
                                                <input
                                                    type='number'
                                                    id='partial_enach_proposed_amount'
                                                    name='partial_enach_proposed_amount'
                                                    className='form-control'
                                                    {...register('partial_enach_proposed_amount')}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="partial_debit_date">
                                                <span>Debit Date </span>
                                                <input
                                                    type='date'
                                                    id='partial_debit_date'
                                                    name='partial_debit_date'
                                                    className='form-control'
                                                    {...register('partial_debit_date')}
                                                />
                                            </label>
                                        </div>
                                    </div>

                                    <div className="col-md-12 px-0">
                                        <div className="form-group mb-0">
                                            <button className="btn btn-primary mt-2"
                                            >
                                                Submit
                                            </button>

                                            <button className="btn btn-warning mt-2 float-right d-none"
                                             type="button"
                                            onClick={btnSkipPartialPayment} >
                                                Skip Partial Payment
                                            </button>
                                        </div>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
}

function mapStateToProps(state) {
    return {
        getBusinessDoneLoansData: state.getBusinessDoneLoansData,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign(reportActions.default, userActions.default, beatPlanActions.default, masterAction.default), dispatch),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(EnachTransactionSchedulingV2);